import { DatePicker, Form } from "antd";
import styled from "styled-components";

export const StyledFormItem = styled(Form.Item)`
  margin-bottom: 11px;
`;

export const StyledDatePicker = styled(DatePicker)`
  display: flex;
  input {
    line-height: 1.572;
  }
`;

export const FileNameSpan = styled.span`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 0 8px;
  line-height: 1.5714285714285714;
  flex: auto;
  transition: all 0.3s;
`;